module.exports = __webpack_public_path__ + "static/example-02-random-89f47e6193eeb531842edcd490259335.png";